import { computed } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore } from 'src/store'

export default function useAuthLinks() {
  const { context }: ContextStore = useContextStore()
  const { siteNameSSO, siteNameAppMT } = context.global.sites
  const { href, origin } = context.global.location

  const patientAuthPath = computed(() => {
    const url = new URL('services/sso/login/', siteNameAppMT)

    url.searchParams.set('preselected_country', context.request.country.iso.toLowerCase())
    url.searchParams.set(
      'client_id',
      context.request.country.is_russia ? 'prodoctorov' : `ydoc_${context.request.country.iso.toLowerCase()}`,
    )
    url.searchParams.set('next', href)

    return url.href
  })

  const profileAuthPath = computed(() => {
    const authOrigin = !context.request.country.is_russia && !context.is_office_ip ? origin : siteNameSSO
    const url = new URL('profile/login/', authOrigin)

    url.searchParams.set('next', href)

    return url.href
  })

  function buildLoginPath(baseUrl: string) {
    if (!baseUrl) {
      return ''
    }

    const url = new URL(baseUrl)

    if (typeof window !== 'undefined') {
      const queryParamNext = new URLSearchParams(window.location.search).get('next')

      if (queryParamNext) {
        url.searchParams.set('next', queryParamNext)
      }
    }

    return url.href
  }

  function loginRelocation(url: string) {
    if (typeof window === 'undefined' || !url) {
      return
    }

    window.location.assign(url)
  }

  return {
    patientAuthPath,
    profileAuthPath,
    buildLoginPath,
    loginRelocation,
  }
}
